module.exports = "/static/assets/42115eaf3865efbbda1feaffc63c9a33.png";